import React from "react";
import OurClients from "./OurClients";
import Testimonials from "./Testimonials";
import ConsultationForm from "./ConsultationForm";
import HomeServices from "./HomeServices";
import DesignsHyderabad from "./DesignsHyderabad";
import InteriorsGallery from "./InteriorsGallery";
import GalleryGrid from "./GalleryGrid";
import ExperienceCentre from "./ExperienceCentre";

const Home = () => {
  return (
    <div>
      <div className="hero hero-video">
        <div className="hero-bg-video">
          <video autoPlay muted loop playsInline id="myVideo">
            <source src="/video/home.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-10">
              <div className="hero-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">
                    MeHome designs spaces that inspire
                  </h3>
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Transform your space with MeHome’s{" "}
                    <b className="home-color">
                      interior design &amp; construction expertise
                    </b>
                  </h1>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    MeHome brings your dream spaces to life. Premium design,
                    expert construction
                  </p>
                </div>

                <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                  <a href="about.html" className="btn-default">
                    About Us
                  </a>
                  <a
                    href="contact.html"
                    className="btn-default btn-highlighted"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-us-images">
                <div className="about-img-1">
                  <figure className="image-anime reveal">
                    <img src="imgs/premier-interior-design.jpg" alt="Premier Interior Design " />
                  </figure>
                </div>
                <div className="about-img-2">
                  <figure className="image-anime reveal">
                    <img src="imgs/premier-interior-design-mehome.jpg" alt="Premier Interior Design " />
                  </figure>
                  <div className="experience-counter">
                    <h3>
                      <span className="counter">6</span>+
                    </h3>
                    <p>Years of experience</p>
                  </div>
                </div>
                <div className="feedback-counter">
                  <p>
                    <span className="counter">95</span>%
                  </p>
                  <h3>positive feedback</h3>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-us-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">MeHome - About us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Premier Interior Design & <span>Construction Services</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    At MeHome, we redefine the way spaces are designed, built,
                    and experienced. With 6+ years of expertise in the interior
                    design and construction industry, we have successfully
                    delivered projects that balance creativity, functionality,
                    and precision engineering. Our goal is simple: to craft
                    spaces that truly reflect the personality, values, and
                    aspirations of our clients.
                  </p>
                </div>

                <div className="about-us-content-body">
                  <div className="about-us-content-info">
                    <div
                      className="about-us-content-list wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <ul>
                        <li>Residential Interiors</li>
                        <li>Commercial & Corporate Spaces</li>
                        <li>Renovations & Space Makeovers</li>
                      </ul>
                    </div>
                  </div>

                  <div className="about-us-contact-list">
                    <div
                      className="about-us-content-list wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <ul>
                        <li>Construction & Turnkey Solutions</li>
                        <li>Modular Kitchens & Custom Furniture</li>
                      </ul>
                    </div>
                    <div
                      className="about-us-content-btn wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <a href="about.html" className="btn-default">
                        read more
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="why-choose-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="why-choose-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">Why Choose MeHome</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Trusted Interior & <span>Construction Experts</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    At MeHome, we believe every space tells a story and we make
                    sure it tells yours beautifully. With 6+ years of
                    experience in interior design and construction, we’ve built
                    our reputation on trust, creativity, and uncompromising
                    quality. Here’s why our clients choose us:
                  </p>
                </div>

                <div className="why-choose-item-list">
                  <div
                    className="why-choose-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img
                        src="/images/icon-why-choose-1.svg"
                        alt="Quality Icon"
                      />
                    </div>
                    <div className="why-choose-item-content">
                      <h3>Quality That Lasts</h3>
                      <p>
                        We use only premium materials, skilled craftsmanship,
                        and modern construction techniques, ensuring durability,
                        functionality, and timeless appeal. Every detail is
                        carefully inspected for perfection.
                      </p>
                    </div>
                  </div>

                  <div
                    className="why-choose-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img
                        src="/images/icon-why-choose-2.svg"
                        alt="Solutions Icon"
                      />
                    </div>
                    <div className="why-choose-item-content">
                      <h3>Complete End-to-End Solutions</h3>
                      <p>
                        From initial concepts, 3D visualizations, planning,
                        approvals, construction, and final handover, everything
                        is managed seamlessly under one roof. With MeHome, you
                        won’t have to juggle multiple contractors—we handle it
                        all.
                      </p>
                    </div>
                  </div>

                  <div
                    className="why-choose-item wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <div className="icon-box">
                      <img
                        src="/images/icon-why-choose-3.svg"
                        alt="Personalized Icon"
                      />
                    </div>
                    <div className="why-choose-item-content">
                      <h3>Personalized Design Approach</h3>
                      <p>
                        We don’t believe in “one-size-fits-all.” Every client
                        has a unique vision, lifestyle, or brand identity. Our
                        team works closely with you to understand your needs,
                        style, and budget, creating customized designs that feel
                        truly personal.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="why-choose-images">
                <div className="why-choose-img-box-1">
                  <div className="why-choose-img-1">
                    <figure className="image-anime reveal">
                      <img src="/imgs/construction-experts.jpg" alt="Design 1" />
                    </figure>
                  </div>
                  <div className="why-choose-img-2">
                    <figure className="image-anime reveal">
                      <img src="/imgs/construction-experts-1.jpg" alt="Design 2" />
                    </figure>
                  </div>
                </div>

                <div className="why-choose-img-box-2">
                  <div className="why-choose-img-3">
                    <figure className="image-anime reveal">
                      <img src="/imgs/construction-experts-2.jpg" alt="Design 3" />
                    </figure>
                  </div>
                  <div className="why-choose-img-4">
                    <figure className="image-anime reveal">
                      <img src="/imgs/construction-experts-3.jpg" alt="Design 4" />
                    </figure>
                  </div>
                </div>

                <div
                  className="about-us-content-btn wow fadeInUp d-flex justify-content-end"
                  data-wow-delay="0.6s"
                >
                  <a href="why-mehome.html" className="btn-default">
                    Read more
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="how-we-work">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-12">
              <div className="section-title dark-section">
                <h3 className="wow fadeInUp"> MeHome Services</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Our <span>   Interior Design Services </span>
                </h2>
              </div>
            </div>
             
          </div>

          <div className="row">
            <div className="col-lg-12">
              
               <HomeServices />
               
            </div>
          </div>
        </div>
      </div>

      {/* OurClients */}

      <OurClients />
      <ExperienceCentre />

      <DesignsHyderabad />

      <div className="vision-mission">
              <div className="container">
                <div className="row section-row align-items-center">
                  <div className="col-lg-12">
                    <div className="section-title dark-section">
                      
                      <h2 className="text-anime-style-2 text-center" data-cursor="-opaque">
                        Our Gallary
                      </h2>

                      <GalleryGrid />
                    </div>
                  </div>

                  
                </div>

          <div className="row">
                  <div className="col-lg-12">
                    <div className="vision-mission-box">
                      

                      <div className="page-gallery">
              <div className="container">
                 
                  
                 
              </div>
            </div>

        </div>
      </div>
    </div>
  </div>
</div>

{/* <InteriorsGallery /> */}

      {/* testimonials */}
      
      <Testimonials />

      

      <ConsultationForm />

    </div>
  );
};

export default Home;
